import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.73 3.8',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M2.78,3.8H1a.24.24,0,0,1-.24-.24V1.73A1.16,1.16,0,0,1,3,1.73V3.56A.24.24,0,0,1,2.78,3.8ZM1.86.7a1,1,0,0,0-1,1V3.56A.12.12,0,0,0,1,3.68H2.78a.12.12,0,0,0,.12-.12V1.73A1,1,0,0,0,1.86.7Z"
        />
        <path
          fill={fill}
          d="M1.56,3.42H1.23A.25.25,0,0,1,1,3.18V2.84a.25.25,0,0,1,.25-.24h.33a.25.25,0,0,1,.25.24v.34A.25.25,0,0,1,1.56,3.42Zm-.33-.7a.12.12,0,0,0-.12.12v.34a.12.12,0,0,0,.12.12h.33a.12.12,0,0,0,.12-.12V2.84a.12.12,0,0,0-.12-.12Z"
        />
        <path
          fill={fill}
          d="M2.5,3.42H2.16a.24.24,0,0,1-.24-.24V2.84a.24.24,0,0,1,.24-.24H2.5a.24.24,0,0,1,.24.24v.34A.24.24,0,0,1,2.5,3.42Zm-.34-.7A.13.13,0,0,0,2,2.84v.34a.12.12,0,0,0,.12.12H2.5a.12.12,0,0,0,.12-.12V2.84a.12.12,0,0,0-.12-.12Z"
        />
        <path
          fill={fill}
          d="M2.33.8A.06.06,0,0,1,2.27.74V.41c0-.16-.19-.29-.41-.29s-.4.13-.4.29V.74A.06.06,0,0,1,1.4.8.07.07,0,0,1,1.33.74V.41A.49.49,0,0,1,1.86,0a.48.48,0,0,1,.53.41V.74A.06.06,0,0,1,2.33.8Z"
        />
        <path
          fill={fill}
          d="M3.49,3.59H3a.06.06,0,0,1-.06-.06A.05.05,0,0,1,3,3.47h.53c.06,0,.12-.08.12-.16V2.5a.15.15,0,0,0-.12-.16H3a.06.06,0,0,1-.06-.06A.05.05,0,0,1,3,2.22h.53a.26.26,0,0,1,.24.28v.81A.27.27,0,0,1,3.49,3.59Z"
        />
        <path
          fill={fill}
          d="M.77,3.59H.24A.27.27,0,0,1,0,3.31V2.5a.26.26,0,0,1,.24-.28H.77a.06.06,0,0,1,.06.06.06.06,0,0,1-.06.06H.24a.15.15,0,0,0-.12.16v.81c0,.08.06.16.12.16H.77a.06.06,0,0,1,.06.06A.06.06,0,0,1,.77,3.59Z"
        />
        <path
          fill={fill}
          d="M1.91,2.27a1.86,1.86,0,0,1-1.18-.5,0,0,0,0,1,0-.08,0,0,0,0,1,.08,0,1.45,1.45,0,0,0,2.1,0,.06.06,0,0,1,.09,0,.06.06,0,0,1,0,.08A1.48,1.48,0,0,1,1.91,2.27Z"
        />
        <path
          fill={fill}
          d="M1.86,1.94a.21.21,0,0,1,0-.42.21.21,0,0,1,0,.42Zm0-.3A.09.09,0,1,0,2,1.73.09.09,0,0,0,1.86,1.64Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
